import { DeviceInfo } from '../DeviceInfo';

export class ExportStartedEventArgs {
    public deviceInfo: DeviceInfo;
    public format: string;
    public handled: boolean = false;

    constructor(deviceInfo: DeviceInfo, format: string) {
        this.deviceInfo = deviceInfo;
        this.format = format;
    }
}
